import { getApp, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

import { GetServicesOutput, IDContractType, Ride } from '../core/apiTypes';
import { isRidePro } from '../utils/business';
import { getPlateformTag } from '../utils/webview';
import { getUser } from '../localStorageAPI';
import configs from '.';

const firebaseConfig = configs.envConfig.currentEnv.firebase;

export default class FirebaseService {
    private static analyticsInstance: ReturnType<typeof getAnalytics> | null = null;

    static initializeFirebase(): void {
        // Initialize Firebase
        initializeApp(firebaseConfig);

        this.getAnalyticsInstance();
    }

    private static getAnalyticsInstance() {
        if (!this.analyticsInstance) {
            const app = getApp(); // Retrieves the existing Firebase app instance
            this.analyticsInstance = getAnalytics(app);
            // Set default platform_source for all queries
            setUserProperties(this.analyticsInstance, { platform_source: getPlateformTag() });
            const user = getUser();
            setUserId(this.analyticsInstance, user?.id || null);
            logEvent(this.analyticsInstance, 'war-login', { id: user?.id });
        }
        return this.analyticsInstance;
    }

    private static executeSafely(callback: (analytics: Analytics) => void): void {
        try {
            const analytics = this.getAnalyticsInstance();
            callback(analytics);
        } catch (error) {
            console.warn('Firebase not initialized:', error);
        }
    }

    static logEvent(key: string, params: { [key: string]: any }): void {
        this.executeSafely((analytics) => {
            let formatedParams = params;
            if (key === 'purchase') {
                const reservation = params as Ride;
                formatedParams = {
                    currency: 'EUR',
                    transaction_id: reservation.id,
                    value: reservation.price_details?.client_final_price,
                    coupon: reservation.price_details?.promotion?.promo_name,
                    discount: reservation.price_details?.promotion?.promo_amount,
                    items: [
                        {
                            item_id: reservation.number,
                            item_name: reservation.service.name,
                            item_category: isRidePro(reservation) ? 'Pro' : 'Perso',
                            quantity: 1,
                            // ...params,
                        },
                    ],
                };
            } else if (key === 'refund') {
                const cancellation = params as any;
                formatedParams = {
                    transaction_id: cancellation.ride_id,
                };
            } else if (key === 'view_item_list') {
                const quotes = params as GetServicesOutput;
                formatedParams = {
                    item_list_id: 'quotes',
                    item_list_name: 'Services',
                    items: quotes.quotes.map((q, index) => {
                        return {
                            item_id: q.id,
                            item_name: q.service.name,
                            item_category:
                                q?.group?.contract?.plan?.type === IDContractType.CORPORTATE ? 'Pro' : 'Perso',
                            coupon: q.price_details?.promotion?.promo_name,
                            discount: q.price_details?.promotion?.promo_amount,
                            index,
                            price: q.price_details?.client_final_price,
                            quantity: 1,
                            // ...q,
                        };
                    }),
                };
            }

            // Add custom param for plateforme
            formatedParams.platform_source = getPlateformTag();

            // console.log('====================================');
            // console.log({ params });
            // console.log('====================================');
            // console.log({ formatedParams });
            // console.log('====================================');
            logEvent(analytics, key, formatedParams);
        });
    }

    static logCurrentPage(screenClass?: string): void {
        this.executeSafely((analytics) => {
            logEvent(analytics, 'screen_view', {
                firebase_screen: window.location.pathname,
                firebase_screen_class: screenClass ?? window.location.pathname,
                platform_source: getPlateformTag(),
            });
        });
    }
}
